<script>
  import { DateInput, localeFromDateFnsLocale } from "date-picker-svelte";
  import { de } from "date-fns/locale";
  import { db } from "./firebase";
  import { collection, addDoc } from "firebase/firestore";

  $: locale = localeFromDateFnsLocale(de);
  let date = new Date();
  let min = new Date("1900-01-01T00:00:00");
  let max = new Date(date.getFullYear() + 2, 12, 31);

  let name = "";

  let type = 1;

  function add() {
    const docRef = addDoc(collection(db, "Feiertag"), {
      Date: date,
      Name: name,
      Type: type,
      Month: date.getMonth(),
      Day: date.getDay(),
    });
    name = "";
  }
</script>

<div>
  <p>Name:</p>
  <input bind:value={name} />
</div>
<div>
  <p>Datum:</p>
  <DateInput
    bind:value={date}
    format="dd.MM.yyyy"
    {locale}
    closeOnSelection="true"
    {min}
    {max}
  />
</div>

<label>
  <input type="radio" bind:group={type} name="types" value={1} />
  Geburtstag
</label>
<label>
  <input type="radio" bind:group={type} name="types" value={2} />
  Hochzeitstag
</label>
<label>
  <input type="radio" bind:group={type} name="types" value={3} />
  Verlobungstag
</label>

<button on:click={add}>Jahrestag hinzufügen</button>
